import { Module } from 'vuex';

import { invoicesService } from '@/services/invoices/invoices.service';
import { Invoice } from '@/services/invoices/invoices.types';
import { RootState } from '@/store';

export interface InvoiceState {
  invoice: Invoice;
  invoiceLoading: boolean;
  downloadLoading: boolean;
}

const state: InvoiceState = {
  invoice: null,
  invoiceLoading: false,
  downloadLoading: false
};

const options: Module<InvoiceState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    setInvoice: ({ commit, dispatch }, invoice: Invoice | string | number): Promise<void> => {
      if (typeof invoice === 'number' || typeof invoice === 'string') return dispatch('getInvoice', invoice);
      else commit('invoice', invoice);
    },
    getInvoice: ({ commit, dispatch }, invoiceId: number): Promise<void> => {
      commit('invoiceLoading', true);
      return invoicesService
        .get(invoiceId)
        .then(invoice => invoice && commit('invoice', invoice))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('invoiceLoading', false));
    },
    clearInvoice: ({ dispatch }): Promise<void> => {
      return dispatch('setInvoice', null);
    },
    saveInvoice: ({ commit, dispatch }, invoiceId: number): Promise<void> => {
      commit('downloadLoading', true);
      return invoicesService
        .downloadInvoice(invoiceId)
        .then(file => file && dispatch('file/saveBase64As', file, { root: true }))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('downloadLoading', false));
    }
  },
  mutations: {
    invoice: (state, invoice: Invoice) => (state.invoice = invoice),
    invoiceLoading: (state, loading: boolean) => (state.invoiceLoading = loading),
    downloadLoading: (state, loading: boolean) => (state.downloadLoading = loading)
  }
};

export default options;
